// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__vfKro","active":"Tag_active__RzwQj"};